import api from "../../utils/api";

const baseEndpoint = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : "";
export const authAPI = api(baseEndpoint);

const authService = {

    login: async (data: any) => {
      return authAPI.post(`/Mobile/Accounts/Login`, data);
    },
    forgotPassword: async (data: any) => {
      return authAPI.post(`/Mobile/Accounts/ForgotPassword`, data);
    },
    signup: async (data: any) => {
      return authAPI.post(`/Mobile/Accounts/Onboarding`, data);
    },
    register: async (data: any) => {
      return authAPI.post(`/Mobile/Accounts/Register`, data);
    },
    getPublicSecurityQuestions: async () => {
      return authAPI.get(`/Mobile/Accounts/GetPublicSecurityQuestions`);
    },

};

export default authService;
